import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const ExpensesList = lazy(() => import('./pages/expensesListPage'))

export const expensesRoutes = () => {
  return (
    <>
      <Route path={pageUrl.expenses} element={<ExpensesList />} />
    </>
  )
}
